import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './UseCases.css';

const UseCases = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const useCases = [
    {
      industry: 'Construction',
      features: [
        'AI project monitoring',
        'Cost & material optimization',
        'Automated reporting & scheduling',
      ],
    },
    {
      industry: 'Automobile',
      features: [
        'Predictive maintenance',
        'Smart manufacturing automation',
        'AI quality inspection',
      ],
    },
    {
      industry: 'Data Centres',
      features: [
        'AI-based performance optimization',
        'Automated fault detection',
        'Energy efficiency management',
      ],
    },
    {
      industry: 'IT & Enterprises',
      features: [
        'AI DevOps automation',
        'Intelligent support systems',
        'AI data processing & management',
      ],
    },
  ];

  return (
    <section className="usecases-section" ref={ref} data-testid="usecases-section">
      <div className="container">
        <motion.div
          className="usecases-header"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <h2 className="section-title" data-testid="usecases-title">
            Industry Use Cases
          </h2>
        </motion.div>

        <div className="usecases-grid">
          {useCases.map((useCase, index) => (
            <motion.div
              key={index}
              className="usecase-card"
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ delay: index * 0.15, duration: 0.5, ease: 'easeOut' }}
              data-testid={`usecase-${index}`}
            >
              <h3 className="usecase-industry">{useCase.industry}</h3>
              <ul className="usecase-features">
                {useCase.features.map((feature, idx) => (
                  <li key={idx} className="usecase-feature">
                    <span className="feature-bullet">▸</span>
                    {feature}
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default UseCases;
